import axios, {AxiosError} from "axios";
import {message} from "antd";

export function attachStageHost(url: string) {
  const [_, splitted] = url.split('://');

  if (window?.location.href.indexOf('dev.') !== -1) return `https://dev.${splitted}`;
  if (window?.location.href.indexOf('stage.') !== -1) return `https://stage.${splitted}`;
  if (window?.location.href.indexOf('http://') !== -1 ) return `https://stage.${splitted}`;
  return url;
}

export function getStageHost() {
      // href 문자열 검색은 ?redirect=http://... 같은 쿼리에도 걸려 인증 토큰이 엉뚱한 호스트로 나간다
      const hostname = window?.location.hostname ?? '';
      const isHttp = window?.location.protocol === 'http:';

      // override 를 먼저 본다. dev./stage. 를 먼저 보면 http://dev.localhost 같은 호스트에서
      // override 가 무시돼 로컬 작업이 stage 로 나간다. 미설정이면 아래 기존 분기로 흐른다
      if (isHttp && process.env.REACT_APP_API_HOST) return process.env.REACT_APP_API_HOST;

      if (hostname.indexOf('dev.') !== -1) return 'https://stage.api.legacy.admin.swingmobility.dev/swing';
      if (hostname.indexOf('stage.') !== -1) return 'https://stage.api.legacy.admin.swingmobility.dev/swing';
      if (isHttp) return 'https://stage.api.legacy.admin.swingmobility.dev/swing';
      return 'https://api.legacy.admin.swingmobility.dev/swing';
    }

  const accessToken =
  localStorage.getItem("accessToken") &&
  `Bearer ${localStorage.getItem("accessToken")}`;

export const AdminApi = axios.create({
  baseURL: getStageHost(),
  headers: {
    authorization: accessToken,
  },
});

export interface CommonListResponse<T> {
  items: T[]
}

export function showMessage(e: AxiosError) {
  if (e.message) {
    message.error(e.message)
  } else {
    console.log(e)
    message.error("알 수 없는 오류가 발생했습니다.")
  }
}
